import type { ProtocolId } from './types';

export interface ProtocolConfig {
  id: ProtocolId;
  nameZh: string;
  nameEn: string;
  /** 中文口播/投影用的序号标签：协议一 … 协议六 */
  tagZh: string;
  colorCount: 4 | 5 | 6 | 7 | 8;
  activeCells: 4 | 5 | 6 | 7 | 8;
  liveScreens: 4 | 2 | 1;
  effectLevel: 0 | 1 | 2 | 3 | 4;
  horror: boolean;
  /** 唯一进阶手段：响应窗口中途把目标切到另一块屏 */
  channelHop: boolean;
  timeLimitMs: number;
  incongruentChance: number;
  speech: boolean;
}

export const PROTOCOLS: Record<ProtocolId, ProtocolConfig> = {
  1: {
    id: 1,
    nameZh: '校准',
    nameEn: 'CALIBRATION',
    tagZh: '协议一',
    colorCount: 4,
    activeCells: 4,
    liveScreens: 4,
    effectLevel: 0,
    horror: false,
    channelHop: false,
    timeLimitMs: 3800,
    incongruentChance: 0.5,
    speech: false,
  },
  2: {
    id: 2,
    nameZh: '干扰',
    nameEn: 'INTERFERENCE',
    tagZh: '协议二',
    colorCount: 5,
    activeCells: 5,
    liveScreens: 4,
    effectLevel: 1,
    horror: false,
    channelHop: false,
    timeLimitMs: 3400,
    incongruentChance: 0.62,
    speech: false,
  },
  3: {
    id: 3,
    nameZh: '阈值',
    nameEn: 'THRESHOLD',
    tagZh: '协议三',
    colorCount: 6,
    activeCells: 6,
    liveScreens: 2,
    effectLevel: 2,
    horror: false,
    channelHop: false,
    timeLimitMs: 3050,
    incongruentChance: 0.74,
    speech: false,
  },
  4: {
    id: 4,
    nameZh: '污染',
    nameEn: 'CONTAMINATION',
    tagZh: '协议四',
    colorCount: 7,
    activeCells: 7,
    liveScreens: 1,
    effectLevel: 2,
    horror: true,
    channelHop: false,
    timeLimitMs: 2750,
    incongruentChance: 0.84,
    speech: true,
  },
  5: {
    id: 5,
    nameZh: '剥夺',
    nameEn: 'DEPRIVATION',
    tagZh: '协议五',
    colorCount: 8,
    activeCells: 8,
    liveScreens: 1,
    effectLevel: 3,
    horror: true,
    channelHop: false,
    timeLimitMs: 2450,
    incongruentChance: 0.9,
    speech: true,
  },
  6: {
    id: 6,
    nameZh: '服从',
    nameEn: 'OBEDIENCE',
    tagZh: '协议六',
    colorCount: 8,
    activeCells: 8,
    liveScreens: 1,
    effectLevel: 4,
    horror: true,
    channelHop: true,
    timeLimitMs: 2150,
    incongruentChance: 0.94,
    speech: true,
  },
};

export const PROTOCOL_ORDER: readonly ProtocolId[] = [1, 2, 3, 4, 5, 6];

export const PROTOCOL_STARTS_MS: readonly number[] = [0, 15_000, 30_000, 45_000, 60_000, 75_000];

export const MATCH_DURATION_MS = 90_000;

/** 每个受试者的灯管数：读错或没读到会烧掉一根，烧完即崩溃 */
export const SUBJECT_STABILITY = 3;

/** 换协议时的喘息时间；最后一个协议给得更长 */
export const PROTOCOL_BREATHER_MS = 2100;
export const FINAL_BREATHER_MS = 3200;

/** 匹配成功后的入场编排时长 */
export const STAGING_MS = 3400;

/** 协议六的频道跳屏发生在窗口的这个比例处 */
export const CHANNEL_HOP_AT = 0.55;

export function protocolForElapsed(elapsedMs: number): ProtocolConfig {
  let index = 0;
  for (let i = PROTOCOL_STARTS_MS.length - 1; i >= 0; i -= 1) {
    if (elapsedMs >= PROTOCOL_STARTS_MS[i]!) {
      index = i;
      break;
    }
  }
  return PROTOCOLS[PROTOCOL_ORDER[index]!];
}
